import React from 'react';

function WelcomeTemplate({ title, message, styling, content }) {
  // ✅ STAGE 1 FIX: Use VITE_API_URL from env
  const API_URL = import.meta.env.VITE_API_URL || window.location.origin;
  const fontFamily = styling?.fontFamily || 'Poppins';
  const bgColor = styling?.backgroundColor || '#5B4E75';
  const accentColor = styling?.accentColor || '#FFFFFF';
  const textColor = styling?.textColor || '#FFFFFF';
  const layoutStyle = styling?.layoutStyle || 'left';
  const mainImage = styling?.mainImage || styling?.announcementImage;
  
  // Editable content with defaults
  const welcomeTagline = content?.welcomeTagline || '';
  const brandName = content?.brandName || '';
  
  
  // ✅ STAGE 4: QR Code settings
  const showQR = content?.ctaEnabled === true;
  const whatsappNumber = '2349055444495';
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=https://wa.me/${whatsappNumber}`;

  // ✅ Check if media is video
  const isVideo = mainImage && (
    mainImage.endsWith('.mp4') ||
    mainImage.endsWith('.webm') ||
    mainImage.endsWith('.ogg')
  );

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        position: 'relative',
        background: bgColor,
        fontFamily: `${fontFamily}, sans-serif`,
        overflow: 'hidden',
      }}
    >
      {/* Main Content Container */}
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: layoutStyle === 'left' ? 'row' : 'row-reverse',
          position: 'relative',
        }}
      >
        {/* Left/Right Section - Text Content */}
        <div
          style={{
            flex: '0 0 50%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '2.5rem 3.5rem',
            position: 'relative',
            zIndex: 2,
          }}
        >
          {/* Decorative Lines - Top Left */}
          <div
            style={{
              position: 'absolute',
              top: '6%',
              left: layoutStyle === 'left' ? '5%' : 'auto',
              right: layoutStyle === 'right' ? '5%' : 'auto',
              width: '100px',
              height: '100px',
            }}
          >
            {[...Array(12)].map((_, i) => (
              <div
                key={i}
                style={{
                  position: 'absolute',
                  width: '2px',
                  height: '120px',
                  background: 'rgba(255, 255, 255, 0.3)',
                  transform: `rotate(${45 + i * 3}deg)`,
                  transformOrigin: 'top left',
                }}
              />
            ))}
          </div>

          {/* Small Tagline */}
{welcomeTagline && (
  <div
    style={{
      fontSize: '0.95rem',
      fontWeight: '600',
      letterSpacing: '0.25em',
      textTransform: 'uppercase',
      color: accentColor,
      marginBottom: '1.2rem',
      opacity: 0.9,
    }}
  >
    {welcomeTagline}
  </div>
)}

          {/* Main Title */}
          <h1
            style={{
              fontSize: styling?.fontSize === 'small' ? '3.5rem' : styling?.fontSize === 'large' ? '5rem' : '4.2rem',
              fontWeight: '900',
              lineHeight: '1.1',
              color: textColor,
              marginBottom: '1.5rem',
              letterSpacing: '-0.02em',
            }}
          >
            {title || brandName}
          </h1>

          {/* Decorative Accent Bar */}
          <div
            style={{
              width: '120px',
              height: '4px',
              background: `linear-gradient(90deg, ${accentColor} 0%, ${accentColor}80 100%)`,
              marginBottom: '2rem',
              borderRadius: '3px',
            }}
          />

          {/* Message/Description */}
          <p
            style={{
              fontSize: '1.5rem',
              lineHeight: '1.6',
              color: textColor,
              opacity: 0.95,
              maxWidth: '500px',
              fontWeight: '400',
            }}
          >
            {message || 'Your premium destination for wellness, beauty, and fitness. Experience excellence in every visit.'}
          </p>

          {/* ✅ STAGE 4: QR Code - Conditional */}
          {showQR && (
            <div
              style={{
                marginTop: '2rem',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '0.8rem',
              }}
            >
              <div
                style={{
                  fontSize: '0.9rem',
                  fontWeight: '600',
                  color: accentColor,
                  opacity: 0.9,
                }}
              >
                Scan to Chat
              </div>
              <img
                src={qrCodeUrl}
                alt="WhatsApp QR Code"
                style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '8px',
                  backgroundColor: '#ffffff',
                  padding: '8px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
                }}
              />
            </div>
          )}

          {/* Decorative Lines - Bottom */}
          <div
            style={{
              position: 'absolute',
              bottom: '10%',
              left: layoutStyle === 'left' ? '5%' : 'auto',
              right: layoutStyle === 'right' ? '5%' : 'auto',
              width: '80px',
              height: '80px',
            }}
          >
            {[...Array(10)].map((_, i) => (
              <div
                key={i}
                style={{
                  position: 'absolute',
                  width: '2px',
                  height: '100px',
                  background: 'rgba(255, 255, 255, 0.2)',
                  transform: `rotate(${-45 + i * 3}deg)`,
                  transformOrigin: 'bottom left',
                }}
              />
            ))}
          </div>
        </div>

        {/* Right/Left Section - Image/Video */}
        <div
          style={{
            flex: '0 0 50%',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {/* Background Decorative Shape */}
          <div
            style={{
              position: 'absolute',
              width: '90%',
              height: '85%',
              background: 'rgba(255, 255, 255, 0.08)',
              borderRadius: '30px',
              transform: 'rotate(-3deg)',
            }}
          />

          {/* Main Media Container */}
          <div
            style={{
              position: 'relative',
              width: '85%',
              height: '80%',
              borderRadius: '25px',
              overflow: 'hidden',
              boxShadow: '0 30px 80px rgba(0, 0, 0, 0.4)',
              zIndex: 1,
            }}
          >
            {mainImage ? (
              isVideo ? (
                <video
                  src={`${API_URL}${mainImage}`}
                  autoPlay
                  loop
                  muted
                  playsInline
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <img
                  src={`${API_URL}${mainImage}`}
                  alt="Welcome"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              )
            ) : (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(135deg, rgba(255,255,255,0.15) 0%, rgba(255,255,255,0.05) 100%)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'rgba(255, 255, 255, 0.5)',
                  fontSize: '1.5rem',
                  fontWeight: '600',
                }}
              >
                Upload Your Image
              </div>
            )}
          </div>

          {/* Decorative Chevrons - Top Right */}
          <div
            style={{
              position: 'absolute',
              top: '8%',
              right: '8%',
              display: 'flex',
              gap: '8px',
            }}
          >
            {[...Array(3)].map((_, i) => (
              <svg
                key={i}
                width="40"
                height="60"
                viewBox="0 0 40 60"
                style={{ opacity: 0.3 - i * 0.1 }}
              >
                <path
                  d="M 5 5 L 30 30 L 5 55"
                  fill="none"
                  stroke={accentColor}
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            ))}
          </div>
        </div>
      </div>

      {/* Floating Decorative Elements */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: layoutStyle === 'left' ? '48%' : '2%',
          fontSize: '3rem',
          opacity: 0.15,
          animation: 'float 4s ease-in-out infinite',
        }}
      >
        ✨
      </div>

      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&family=Roboto:wght@400;500;700;900&family=Poppins:wght@400;500;600;700;800;900&family=Montserrat:wght@400;500;600;700;800;900&family=Raleway:wght@400;500;600;700;800;900&family=Playfair+Display:wght@400;500;600;700;800;900&display=swap');
          
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(0deg); }
            50% { transform: translateY(-25px) rotate(5deg); }
          }
        `}
      </style>
    </div>
  );
}

export default WelcomeTemplate;